import React from 'react'
export default function ImgSet(props) {
  let srcSet = ''
  if (props.src2x) {
    srcSet += `${props.src2x} 2x,`
  }

  if (props.src3x) {
    srcSet += `${props.src3x} 3x`
  }

  return <img src={props.src} srcSet={srcSet} alt={props.alt} />
}
